<template>
    <v-card>
      <v-card-title @click="hide_chat=!hide_chat" class="primary pa-0 ma-0 background--text" dark>
        <v-btn icon small>
          <v-icon small color="background">$vuetify.icons.message</v-icon>
        </v-btn>
        <div class="pa-0 ma-0">{{stream.title}}</div>
        <v-spacer></v-spacer>
        <v-btn small icon class="background--text">
          <v-icon small v-if="!hide_chat">$vuetify.icons.rms_close</v-icon>
          <v-icon small v-else>$vuetify.icons.rms_debit_tree</v-icon>
        </v-btn>
      </v-card-title>
      <v-layout v-show="!hide_chat" class="scroll-container">
        <v-flex>
          <div
            class="chat-container"
            style="text-align: justify !important;height:300px;"
            v-on:scroll="onScroll"
            ref="chatContainer"
          >
            <template v-for="(message, index) in messages">
              <v-flex class="messageStyle" :key="index" :class="{own: message.user == username}">
                <div
                  style="font-size:12px"
                  class="username"
                  v-if="index>0 && messages[index-1].user != message.user"
                >{{authorName(message.user)}}</div>
                <div
                  style="font-size:12px"
                  class="username"
                  v-if="index == 0"
                >{{authorName(message.user)}}</div>
                <div style="margin-top: 5px !important"></div>
                <div class="content text-justify">
                  <div v-linkified>{{message.content}}</div>
                </div>
              </v-flex>
            </template>
          </div>
          <div class="typer">
            <input
              type="text"
              placeholder="Type here..."
              v-on:keyup.enter="sendMessage"
              v-model="content"
            />
            <v-icon @click="sendMessage" color="primary">$vuetify.icons.send</v-icon>
          </div>
        </v-flex>
      </v-layout>
    </v-card>

</template>
<script>
import * as firebase from "firebase";
import { mapState } from "vuex";

export default {
  props: ["stream"],
  data() {
    return {
      content: "",
      chatMessages: [],
      currentRef: {},
      loading: false,
      totalChatHeight: 0,
      id: null,
      hide_chat: false
    };
  },
  mounted() {
    this.loadChat();
  },
  computed: {
    ...mapState({
      username: state => state.consumer.profile.email
    }),
    messages() {
      return this.chatMessages;
    },
    onNewMessageAdded() {
      const that = this;
      let onNewMessageAdded = function(snapshot, newMessage = true) {
        let message = snapshot.val();
        message.key = snapshot.key;
        message.content = message.content;
        if (!newMessage) {
          that.chatMessages.unshift(that.processMessage(message));
          that.scrollTo();
        } else {
          that.chatMessages.push(that.processMessage(message));
          that.scrollToEnd();
        }
      };
      return onNewMessageAdded;
    }
  },
  watch: {
    "$route.params.id"(newId, oldId) {
      this.currentRef.off("child_added", this.onNewMessageAdded);
      this.loadChat();
    }
  },
  methods: {
    authorName(name) {
      if (!name) {
        return;
      }
      name = name.substring(0, name.lastIndexOf("@"));
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return name;
    },
    loadChat() {
      this.id = this.$route.params.screener_id;
      this.totalChatHeight = this.$refs.chatContainer.scrollHeight;
      this.loading = false;
      if (this.id !== undefined) {
        this.chatMessages = [];
        let chatID = this.id;
        this.currentRef = firebase
          .database()
          .ref("messages")
          .child(chatID)
          .child("messages")
          .limitToLast(20);
        this.currentRef.on("child_added", this.onNewMessageAdded);
      }
    },
    onScroll() {
      let scrollValue = this.$refs.chatContainer.scrollTop;
      const that = this;
      if (scrollValue < 100 && !this.loading) {
        this.totalChatHeight = this.$refs.chatContainer.scrollHeight;
        this.loading = true;
        let chatID = this.id;
        let currentTopMessage = this.chatMessages[0];
        if (currentTopMessage === undefined) {
          this.loading = false;
          return;
        }
        firebase
          .database()
          .ref("messages")
          .child(chatID)
          .child("messages")
          .orderByKey()
          .endAt(currentTopMessage.key)
          .limitToLast(20)
          .once("value")
          .then(function(snapshot) {
            let tempArray = [];
            snapshot.forEach(function(item) {
              tempArray.push(item);
            });
            if (
              tempArray[1] == undefined ||
              tempArray[0].key === tempArray[1].key
            )
              return;
            tempArray.reverse();
            tempArray.forEach(function(child) {
              that.onNewMessageAdded(child, false);
            });
            that.loading = false;
          });
      }
    },
    processMessage(message) {
      /*eslint-disable */
      var imageRegex = /([^\s\']+).(?:jpg|jpeg|gif|png)/i;
      /*eslint-enable */
      if (imageRegex.test(message.content)) {
        message.image = imageRegex.exec(message.content)[0];
      }
      var emojiRegex = /([\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{2934}-\u{1f18e}])/gu;
      if (emojiRegex.test(message.content)) {
        message.content = message.content.replace(
          emojiRegex,
          '<span class="emoji">$1</span>'
        );
      }
      return message;
    },
    sendMessage() {
      if (this.content !== "") {
        var self = this;
        const message = {
          user: this.username,
          content: this.content,
          date: new Date().toString()
        };
        firebase
          .database()
          .ref("messages")
          .child(this.id)
          .child("messages")
          .push(message)
          .then(data => {})
          .catch(error => {
            self.$store.dispatch("app/showMessage", {
              message: error.message,
              color: "error"
            });
          });
        this.content = "";
      }
    },
    scrollToEnd() {
      this.$nextTick(() => {
        var container = this.$el.querySelector(".chat-container");
        container.scrollTop = container.scrollHeight;
      });
    },
    scrollTo() {
      this.$nextTick(() => {
        let currentHeight = this.$refs.chatContainer.scrollHeight;
        let difference = currentHeight - this.totalChatHeight;
        var container = this.$el.querySelector(".chat-container");
        container.scrollTop = difference;
      });
    }
  }
};
</script>
<style scoped>
.typer {
  border-top: 1px solid grey;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  bottom: 0;
  height: 3.3rem;
  width: 100%;
  box-shadow: 0 -5px 10px -5px rgba(0, 0, 0, 0.2);
}
.typer input[type="text"] {
  padding: 1rem;
  width: 97%;
  background-color: transparent;
  border: none;
  outline: none;
  font-size: 1.25rem;
}
.chat-container {
  box-sizing: border-box;
  overflow-y: auto;
  padding: 10px;
}
.messageStyle {
  margin-bottom: 3px;
}
.messageStyle.own {
  text-align: right;
}
.messageStyle.own .content {
  background-color: black;
  color: white;
}
.chat-container .content {
  padding: 8px;
  background-color: #dcdcdc;
  color:black;
  border-radius: 10px;
  display: inline-block;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 2px 1px -1px rgba(0, 0, 0, 0.12);
  max-width: 70%;
  word-wrap: break-word;
}
</style>
